import { actionCreator as ac } from '../helpers/actionCreator'

const ns = type => `WIDTH_AND_HEIGHT_${type}`

export const UPDATE = ns('UPDATE')
export const update = ac(UPDATE)
